(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('FncDxRepository', [
        'AprimaRestangular',
        FncDxRepository
    ]);
    
    function FncDxRepository(
        AprimaRestangular
    ) {
        return {
            getDiagnoses: getDiagnoses,
            postImoDiagnoses: postImoDiagnoses,
            postDiagnoses: postDiagnoses,
            deleteDiagnosis: deleteDiagnosis,
            deleteDiagnoses: deleteDiagnoses,
        };

        function getDiagnoses(patientId, visitId) {
            return AprimaRestangular.get()
                .one('patients', patientId)
                .one('fnc', visitId)
                .all('dx')
                .getList();
        }

        function postImoDiagnoses(patientId, visitId, result) {
            return AprimaRestangular.get()
                .one('patients', patientId)
                .one('fnc', visitId)
                .all('dx-term')
                .post(result);
        }

        function postDiagnoses(patientId, visitId, result) {
            return AprimaRestangular.get()
                .one('patients', patientId)
                .one('fnc', visitId)
                .all('dx')
                .post(result);
        }

        function deleteDiagnosis(patientId, visitId, diagnosisId) {
            return AprimaRestangular.get()
                .one('patients', patientId)
                .one('fnc', visitId)
                .one('dx', diagnosisId)
                .remove();
        }

        function deleteDiagnoses(patientId, visitId, diagnosisIds) {
            return AprimaRestangular.get()
                .one('patients', patientId)
                .one('fnc', visitId)
                .all('dx')
                .remove({
                    diagnosisIds: diagnosisIds,
                });
        }
    }
})();
